export default __webpack_public_path__ + "static/brand-logo-nicholsons-94296a45f50ec17bbc56435de03002bb.png";